import React from 'react';
import {
  Row, Col, Button, Spin, Icon, Pagination
} from 'antd';
import { inject, observer } from 'mobx-react';
import LazyLoad from 'react-lazy-load';
import util from '../../util';
import base from '../../tool/base';
import Tab from './tab/index';
import RadioSort from '../util/RadioSort';

const { isWeaver, getAccessToken } = util;
const store = [
  'collectStore',
  'homeStore',
  'initStore',
  'themeListStore',
  'oldApplyStore',
  'listStore',
  'modeListStore',
  'caseListStore',
]
@inject(...store)
@observer
class App extends React.Component {

  constructor(props) {
    super(props);
    this.scrollTop = 0;
    this.state = {}
  }

  componentDidMount() {
    const { listStore: { params: { searchValue } }, themeListStore: { getThemeList, getThemeE8List }, version } = this.props;
    version === 'e9' ? 
      getThemeList({ title: searchValue, pageNum: 1 }) :
      getThemeE8List({searchValue});
  }
  
  //e8门户方法
  collect = (e, data) => {
    const { listStore: { params: { searchValue } }, themeListStore: { getThemeE8List, callCollect }  } = this.props;
    callCollect({ collect: data.tms_iscoll === '1' ? '0' : '1', s_ids: data.sw_id }).then(data => {
      getThemeE8List({ searchValue, pageNum: 1 });
    });
    e.stopPropagation && e.stopPropagation();
    e.preventDefault && e.preventDefault();
    e.nativeEvent && e.nativeEvent.preventDefault();
  }

  /**
   * 申请主题权限
   * @param {any} e 
   * @param {any} obj 
   * @param {boolean} api 
   */
  apply = (e, obj, api = true) => {
    const { modeListStore: { setMobxState, getAppDetail }, caseListStore: { setApply, setState } } = this.props;
    if(api) {
      getAppDetail({ id: obj.id }).then(() => {
        setMobxState({ visibleOfApply: true });
      });
    } else {
      setApply({appId: obj.id, title: obj.name, kb: obj.kb});
      setState({applyVisible: true});
    }
    e.stopPropagation && e.stopPropagation();
    e.preventDefault && e.preventDefault();
    e.nativeEvent && e.nativeEvent.preventDefault();
  }


  applyPermissions = (e, obj) => {
    const { caseListStore: { setApply, setState } } = this.props;

    setApply({appId: obj.id, title: obj.name, kb: obj.kb});
    setState({applyVisible: true, isPermissions: true});

    e.stopPropagation && e.stopPropagation();
    e.preventDefault && e.preventDefault();
    e.nativeEvent && e.nativeEvent.preventDefault();
  }

  onClick = (e, id) => {
    const { homeStore: { setType, routing } } = this.props;
    routing.push(`/app/appDetail/${id}`);
    setType('theme', '门户主题');
    e.stopPropagation && e.stopPropagation();
    e.preventDefault && e.preventDefault();
    e.nativeEvent && e.nativeEvent.preventDefault();
  }
  download = (id, folderId) => {
    const url = `${window.server}/v5/ecode/download?id=${id}&access_token=${getAccessToken()}`;
    const { themeListStore: { getThemeList, params }, listStore: { params: { searchValue } } } = this.props;
    base.callApi('/v5/ecode/downloadCount', 'POST', {appId: folderId}, 'json', 'text').then((data) => {
      if (data.status) {
        window.open(url);
        getThemeList({title: searchValue});
      } else {
        console.error("后端接口异常，请联系管理员！");
      }
    });
  }
  previewCase = (readme) => {
    const { previewCase } = this.props;
    typeof previewCase === 'function' && previewCase(readme);
  }
  doThumbsub = (folderId) => {
    const { themeListStore: { thumbsupAdd, getThemeList, params, thumbsupAddLoading }, listStore: { params: { searchValue } } } = this.props;
    !thumbsupAddLoading && thumbsupAdd({ appId: folderId }).then(() => {
      getThemeList({ title: searchValue, current: 1, }, false);
    });
  }
  onChange = value => {
    const { themeListStore: { setState, getThemeList }, listStore: { params: { searchValue } } } = this.props;
    setState({orderby: value});
    getThemeList({title: searchValue});
  }

  //e9和e8门户共用方法
  onPageChange = (pageNum, pageSize) => {
    const { themeListStore: { setState, getThemeList, getThemeE8List }, listStore: { params: { searchValue } }, version } = this.props;
    if(version === 'e9') {
      setState({pageE9: {pageNum, pageSize}});
      getThemeList({title: searchValue});
    } else {
      setState({pageE8: {pageNum, pageSize}});
      getThemeE8List({searchValue});
    }    
  }

  render() {
    const { 
      themeListStore: { getThemeList, orderby, themeList: themeListE9, themeListE8, pageE9, countE9, pageE8, countE8, loadingE8, loadingE9 },
      homeStore: { view, addCollect, addCollectLoading },
      listStore: { params: { searchValue } },
      version,
      width,
    } = this.props;
    const page = version === 'e9' ? pageE9 : pageE8,
          count = version === 'e9' ? countE9 : countE8,
          loading = version === 'e9' ? loadingE9 : loadingE8,
          themeList = version === 'e9' ? themeListE9 : themeListE8;
    const isSearch = window.location.hash.indexOf('app/search') >= 0;
    const sortList = [{
      label:  <span>
                最新
                <svg className="icon-font sort-btn-icon" aria-hidden="true">
                  <use href="#icon-Down-"></use>
                </svg>
              </span>,
      value: 'createdate',
    }, {
      label:  <span>
                最热
                <svg className="icon-font sort-btn-icon" aria-hidden="true">
                  <use href="#icon-Down-"></use>
                </svg>
              </span>,
      value: 'downloadcounts',
    }, {
      label:  <span>
                访问量
                <svg className="icon-font sort-btn-icon" aria-hidden="true">
                  <use href="#icon-Down-"></use>
                </svg>
              </span>,
      value: 'visits',
    }];
    return (
      <div className='home-page-theme-list'>
        <Tab title={`门户主题(${version.toUpperCase()})`} span={24} offset={0} style={{ paddingBottom: 14 }} more={false}/>
        {
          version === 'e9' ? <RadioSort
            datas={sortList}
            value={orderby}
            className="theme-list-sort"
            onChange={this.onChange}
          /> : null
        }
        
        <Row
          ref={c => this.themeList = c}
          style={isSearch ? { paddingTop: 20 } : {}}
          className="home-page-theme-list-body"
        >
          <Spin spinning={loading}>
            {
              themeList.length > 0
                ?
                themeList.map((t, i) => {
                  const span = width <= 1500 ? 8 : 6;
                  const isE9 = version === 'e9';
                  return (
                    <Col
                      key={(t.id || t.sw_id)}
                      className='home-page-theme-list-item'
                      span={span}
                    >
                      <div className='home-page-theme-list-item-card'
                        onClick={(e) => {
                          if(t.attr && t.attr.caseType === 'app') return;
                          this.onClick(e, t.id || t.sw_id)
                        }}
                        style={{ height: (width - (width <= 1500 ? 220 : 230)) * 9 / (16 * (width <= 1500 ? 3 : 4)) }}
                      >
                        <span className="version-tag" style={isE9 ? { background: '#007AFF' } : {}}>
                          {isE9 ? 'E9' : 'E8' }
                        </span>
                        <LazyLoad height='100%'>
                          <img src={t.imageList ? t.imageList[0].imageLink : `https://www.e-cloudstore.com/${t.s_docfile}`} alt='' />
                        </LazyLoad>
                        <div className='theme-card-mask' />
                        <div className='theme-card-title'>
                          <h1>{t.title || t.s_name}</h1>
                          <p>
                            {
                              !isE9 ? (
                                <Button
                                  type='primary'
                                  onClick={(e) => {
                                    e.stopPropagation && e.stopPropagation();
                                    e.preventDefault && e.preventDefault();
                                    e.nativeEvent && e.nativeEvent.preventDefault();
                                    if(t.sw_id) {
                                      view(t);
                                    }else {
                                      this.previewCase(t.readme);
                                    }
                                  }}
                                >
                                  预览
                                </Button> 
                              ) : (
                                <Button
                                  style={{ padding: "0 16px" }}
                                  disabled={!isWeaver()}
                                  onClick={(e) => {
                                    this.applyPermissions(e, {id: t.folderId || t.sw_id, name: t.title, kb: t.kbVersion})
                                  }}
                                >
                                  申请开发授权
                                </Button> 
                              )
                            }
                            {(t.attr && t.attr.caseType === 'app') ||  t.s_name ? 
                              <Button
                                style={{ marginLeft: 30 }}
                                disabled={!isWeaver()}
                                onClick={(e) => {
                                  this.apply(e, {id: t.folderId || t.sw_id, name: t.title, kb: t.kbVersion}, !(t.attr && t.attr.caseType === 'app'))
                                }}
                              >
                                申请主题
                              </Button> : 
                              <Button
                                style={{ marginLeft: 30 }}
                                disabled={!isWeaver()}
                                onClick={() => {
                                  this.download(t.id || t.sw_id, t.folderId || t.id)
                                }}
                              >
                                下载
                              </Button>
                            }
                          </p>
                        </div>
                        {
                          isWeaver() && !isE9 && !t.attr && (
                            <div className="theme-card-title-collect" onClick={(e) => this.collect(e, t)}>
                              {t.tms_iscoll === '1' ? (<Icon type="star" />) : (<Icon type="star" theme="filled" style={{ color: '#1e94ff' }} />) }
                              <span>{t.tms_iscoll === '1' ? '收藏' : '取消收藏'}</span>
                            </div>
                          )
                        }
                      </div>
                      <div className='home-page-theme-e9Info'>
                        {
                          isE9 && (
                            <div  className="home-page-theme-e9Info-num" key="home-page-theme-e9Info-num">
                              <span className="home-page-theme-e9Info-num-left">
                                <Icon type="eye" className="home-page-theme-e9Info-num-icon" />
                                {t.visits || 0}
                              </span>
                              <span className="home-page-theme-e9Info-num-left">
                                <Icon type="download" className="home-page-theme-e9Info-num-icon" />
                                {t.downloadCounts || 0}
                              </span>
                              <span>
                                {/* <Icon type="like" className="home-page-theme-e9Info-num-icon" /> */}
                                <Icon type="like"
                                  className={`home-page-theme-e9Info-num-icon icon-heart ${t.thumbsupStatus === 'y' ? "heart-active" : ""}`}
                                  theme={t.thumbsupStatus === 'y' ? "filled" : "" }
                                  onClick={() => this.doThumbsub(t.folderId) }
                                />
                                {t.thumbsup || 0}
                              </span>
                              <div className="home-page-theme-e9Info-desc">
                                <span 
                                  className="home-page-theme-e9Info-desc-single" 
                                  onClick={() => {
                                    if(!addCollectLoading) { 
                                      addCollect({appId: t.folderId}).then(data => 
                                        data.status && getThemeList({ title: searchValue, pageNum: 1 }, false)
                                      );
                                    }
                                  }}
                                >
                                  {t.starStatus === 'y' ? '取消收藏' : '收藏'}
                                </span>
                                {
                                  t.attr && t.attr.detailsUrl && t.attr.detailsUrl !== '' && (
                                    <span className="home-page-theme-e9Info-desc-single" onClick={() => window.open(t.attr.detailsUrl)}>
                                      详情
                                    </span>
                                  )
                                }
                                {
                                  t.attr && t.attr.previewUrl && t.attr.previewUrl !== '' && (
                                    <span className="home-page-theme-e9Info-desc-single" onClick={() => window.open(`${t.attr.previewUrl}&ecodessoid=test`)}>
                                      预览
                                    </span>
                                  )
                                }
                              </div>
                            </div>
                          )
                        }
                        <div key="home-page-theme-e9Info-title" className={`home-page-theme-e9Info-title${isE9 ? '' : '-e8'} text-elli`} title={t.title || t.s_name}>
                        {t.title || t.s_name}
                        </div>
                      </div>
                      {/* <p className='theme-card-desc'>{t.title || t.s_name}</p> */}
                    </Col>
                  )
                }
                )
                : loading
                  ? <div style={{ width: '100%', height: 300 }} />
                  : <div style={{minHeight: 400, paddingTop: 120}}>
                      <div className="icon-Cloud-No-data" />
                      <p style={{ textAlign: 'center' }}>暂无数据</p>
                    </div>
            }
          </Spin>
        </Row>
        <Pagination
          className="home-page-theme-pagination"
          current={page.pageNum}
          pageSize={page.pageSize}
          total={count}
          showSizeChanger
          showQuickJumper
          pageSizeOptions={['12', '24', '36', '48']}
          onChange={this.onPageChange}
          onShowSizeChange={this.onPageChange}
        />
      </div>
    )
  }
}

export default App


// WEBPACK FOOTER //
// ./src/components/home/ThemeItem.js